import React, { FC } from 'react'
import classNames from 'classnames'
import { IFullStop } from 'types'
import { StopsSummaryConnectorIcon } from 'apps/fleet-planner/components/load-details/stops/StopsSummaryConnectorIcon'
import { useStopSummaryConnector } from 'apps/fleet-planner/components/load-details/stops/StopsSummaryStyles'
import { IStop } from 'apps/fleet-planner/types'

interface IStopsSummaryConnectorProps {
  stops: IStop[] | IFullStop[]
  compact?: boolean
}

/**
 * Connecting line between stops in summary
 */
export const StopsSummaryConnector: FC<IStopsSummaryConnectorProps> = ({
  stops = [],
  compact = false,
}) => {
  const styles = useStopSummaryConnector({ compact })
  const isMultiStop = stops.length > 2
  const additionalStopsCount = stops.length - 2
  const classes = classNames(styles.root, {
    [styles.multiStop]: isMultiStop,
  })
  return (
    <div className={classes}>
      <StopsSummaryConnectorIcon isMultiStop={isMultiStop} compact={compact} />
      {isMultiStop && (
        <span>
          {additionalStopsCount} additional stop{additionalStopsCount > 1 ? 's' : ''}
        </span>
      )}
    </div>
  )
}
